export default __webpack_public_path__ + "static/media/741hz-toxin-cleanse.9acc8198.mp3";